/* @flow */
import React from 'react';
import { HousePropsList, HousePropsItem, HousePropsTitle, HousePropsValue } from '../../ApartPage/styles';

type TProp = {
	title: string,
	value: string,
	isBig?: boolean,
};

type TProps = {
	data: TProp[],
};

const HouseProps = ({ data }: TProps) => (
	<HousePropsList>
		{data.map(
			(item) =>
				item.value && (
					<HousePropsItem key={item.title}>
						<HousePropsTitle>{item.title}</HousePropsTitle>
						<HousePropsValue $isBig={item.isBig}>{item.value}</HousePropsValue>
					</HousePropsItem>
				),
		)}
	</HousePropsList>
);

export default HouseProps;
